import { TFunction } from '@lyearn/i18n';
import { ResourceTypeEnum } from '@/types/schema';

export enum PublishChangesTab {
  Publish = 'PUBLISH',
  SharePublicly = 'SHARE_PUBLICLY',
}

export const getTabs = (t: TFunction, contentType?: ResourceTypeEnum) => {
  if (contentType === ResourceTypeEnum.Article) {
    return [
      { value: PublishChangesTab.Publish, label: t('Common:Actions.Publish'), enabled: true },
      { value: PublishChangesTab.SharePublicly, label: t('Article:SharePublicly'), enabled: true },
    ];
  }
  return [];
};
